// extracted by mini-css-extract-plugin
export var divider = "_dk-7";
export var itemsToggle = "_dk-8";
export var mergeModal = "_dk-1";
export var optionCard = "_dk-4";
export var radioGroup = "_dk-6";
export var radioOption = "_dk-0";
export var selected = "_dk-5";
export var shipmentOptions = "_dk-2";
export var tableOptions = "_dk-3";